import { observable, runInAction } from "mobx";
import { IDispatch, IDispatchDetail, IDispatchHistory, IDispatchList, IDispatchStatus, IDispatchUpdate } from "src/Interfaces/DispatchInterface";
import { API } from "src/Services/Api/Api";
import { RootStore } from "../Root/RootStore";

class DispatchApi {
    private api: API;
    constructor(api: API) {
        this.api = api;
    }

    public getDispatches() {
        return this.api.get('/dispatch');
    }

    public getDispatch(dispatchId: string) {
        return this.api.get(`/dispatch/${dispatchId}`);
    }

    public postDispatch(dispatch: IDispatch) {
        return this.api.post('/dispatch', dispatch);
    }

    public putDispatch(dispatch: IDispatchUpdate) {
        return this.api.put(`/dispatch/${dispatch.id}`, dispatch);
    }

    public updateDispatchStatus(dispatchId: string, dispatchStatus: IDispatchStatus) {
        return this.api.put(`/dispatch/${dispatchId}/status`, dispatchStatus);
    }

    public setTruckDelivered(truckId: string) {
        return this.api.post(`/dispatch/truck/${truckId}/delivered`, {});
    }

    public setTruckCompleted(truckId: string) {
        return this.api.post(`/dispatch/truck/${truckId}/completed`, {});
    }

    public addComment(comment: string, dispatchId: string) {
        return this.api.post(`/dispatch/${dispatchId}/comment`, { comment });
    }
}

export class DispatchStore {

    public RootStore: RootStore;
    public api: DispatchApi;

    @observable
    public dispatches: IDispatchList[];

    @observable
    public dispatch: IDispatchDetail;

    constructor(rootStore: RootStore) {
        this.RootStore = rootStore;
        this.api = new DispatchApi(rootStore.Api);
    }

    public async getDispatches() {
        const dispatches = await this.api.getDispatches();
        if (dispatches) {
            runInAction(() => {
                this.dispatches = dispatches;
            });
            return dispatches;
        }
    }

    public async getDispatch(dispatchId: string) {
        const dispatch = await this.api.getDispatch(dispatchId);
        if (dispatch) {
            runInAction(() => {
                this.dispatch = dispatch;
            });
            return dispatch;
        }
    }

    public getDispatchType(dispatch: IDispatchHistory | undefined) {
        if (!dispatch) {
            return '';
        }
        return dispatch.dispatchHeader.type;
    }
    public postDispatch(dispatch: IDispatch) {
        return this.api.postDispatch(dispatch);
    }

    public putDispatch(dispatch: IDispatchUpdate) {
        return this.api.putDispatch(dispatch);
    }

    public updateDispatchStatus(dispatchId: string, dispatchStatus: IDispatchStatus) {
        return this.api.updateDispatchStatus(dispatchId, dispatchStatus);
    }

    public setTruckDelivered(truckId: string) {
        return this.api.setTruckDelivered(truckId);
    }

    public setTruckCompleted(truckId: string) {
        return this.api.setTruckCompleted(truckId);
    }

    public async addComment(comment: string) {
        const retComment = await this.api.addComment(comment, this.dispatch.id);
        runInAction(() => {
            this.dispatch.comments.unshift(retComment);
        });
        return retComment;
    }
}


// WEBPACK FOOTER //
// ./src/Stores/Dispatch/DispatchStore.ts